import Vue from "vue";
import VueRouter from "vue-router";
import DefaultLayout from "~/layouts/default.vue";
import LoginLayout from "~/layouts/login.vue";
import PrivacyPolicy from "~/layouts/privacypolicy.vue";
import ForBidden from "~/layouts/forbidden.vue";
import PageNotFound from "~/layouts/pagenotfound.vue";
import ServerError from "~/layouts/servererror.vue";
import Home from "~/pages/Home.vue";
import Setting from "~/pages/setting/index.vue";
import PhoneFixList from "~/pages/phonefix/index.vue";
import PhoneFixDetail from "~/pages/phonefix/_id.vue";
import CreatePhoneFix from "~/pages/phonefix/CreatePhoneFix.vue";
import PhoneBuyList from "~/pages/phonebuy/index.vue";
import PhoneBuyDetail from "~/pages/phonebuy/_id.vue";
import PhieuBaoHanh from "~/pages/PhieuBaoHanh.vue";
import PhieuSuaChua from "~/pages/PhieuSuaChua.vue";
import PhieuSuaChuaCuaHang from "~/pages/PhieuSuaChuaCuaHang.vue";
import CreatePhoneBuy from "~/pages/phonebuy/CreatePhoneBuy.vue";
import ImportFile from "~/pages/importfile/index.vue";
import User from "~/pages/user/index.vue";
import UserDetail from "~/pages/user/_id.vue";
import CreateNewUser from "~/pages/user/CreateUser.vue";
import CreateElevatorUser from "~/pages/user/CreateElevatorUser.vue";
import Statistic from "~/pages/statistic/index.vue";
import Login from "~/pages/Login.vue";
import Profile from "~/pages/Profile.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: DefaultLayout,
    children: [
      {
        path: "/",
        name: "Trang Tổng Quan",
        component: Home,
        meta: {
          title: "Tổng quan | Elehome",
          breadcrumbs: "Tổng quan",
        },
      },
      {
        path: "sua-chua",
        meta: {
          title: "Sửa chữa",
          breadcrumbs: "Sửa chữa",
        },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            name: "PhoneFixList",
            component: PhoneFixList,
          },
          {
            path: "chi-tiet-sua-chua/:phonefixId",
            name: "PhoneFixDetail",
            component: PhoneFixDetail,
            meta: {
              title: "Chi tiết sửa chữa",
              breadcrumbs: "Chi tiết sửa chữa",
            },
          },
          {
            path: "tao-sua-chua-moi",
            name: "CreatePhoneFix",
            component: CreatePhoneFix,
            meta: {
              title: "Tạo mới sửa chữa",
              breadcrumbs: "Tạo mới sửa chữa",
            },
          }
        ],
      },
      {
        path: "nguoi-dung",
        meta: {
          title: "Người dùng",
          breadcrumbs: "Người dùng",
        },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            name: "UserList",
            component: User,
          },
          {
            path: "chi-tiet-nguoi-dung/:userId",
            name: "UserDetail",
            component: UserDetail,
            meta: {
              title: "Chi tiết người dùng",
              breadcrumbs: "Chi tiết người dùng",
            },
          },
          {
            path: "tao-nguoi-dung-moi",
            name: "CreateNewUser",
            component: CreateNewUser,
            meta: {
              title: "Tạo người dùng mới",
              breadcrumbs: "Tạo người dùng mới",
            },
          },
          {
            path: "them-thang-may-nguoi-dung/:userId",
            name: "CreateElevatorUser",
            component: CreateElevatorUser,
            meta: {
              title: "Thêm tháng máy người dùng",
              breadcrumbs: "Thêm tháng máy người dùng",
            },
          }
        ],
      },
      {
        path: "bao-hanh",
        meta: {
          title: "Bảo hành",
          breadcrumbs: "Bảo hành"
        },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            component: PhoneBuyList,
            name: "PhoneBuyList",
          },
          {
            path: "tao-bao-hanh-moi",
            component: CreatePhoneBuy,
            name: "CreatePhoneBuy",
            meta: {
              title: "Tạo bảo hành mới",
              breadcrumbs: "Tạo bảo hành mới"
            },
          },
          {
            path: "chi-tiet-bao-hanh/:phonbuyid",
            component: PhoneBuyDetail,
            name: "PhoneBuyDetail",
            meta: {
              title: "Chi tiết bảo hành",
              breadcrumbs: "Chi tiết bảo hành"
            },
          },
        ],
      },
      {
        path: "nhap-file",
        meta: {
          title: "Nhập file",
          breadcrumbs: "Nhập file",
        },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "",
            name: "ImportFile",
            component: () => import ("~/pages/importfile/index.vue"),
          }
        ],
      },
      {
        path: "/thong-ke",
        name: "Thống kê",
        component: Statistic,
        meta: {
          title: "Thống kê | Elehome",
          breadcrumbs: "Thống kê",
        },
      },
      {
        path: "/cai-dat",
        name: "Cài đặt",
        component: Setting,
        meta: {
          title: "Cài đặt | Elehome",
          breadcrumbs: "Cài đặt",
        },
      },
      {
        path: "/tai-khoan",
        name: "Tài khoản",
        component: Profile,
        meta: {
          title: "Tài khoản | Elehome",
          breadcrumbs: "Tài khoản",
        },
      }
    ],
  },
  {
    path: "",
    component: LoginLayout,
    children: [
      {
        path: "dang-nhap",
        name: "Login",
        component: Login,
        meta: {
          title: "Đăng nhập",
          breadcrumbs: "Đăng nhập",
          breadcrumbs: "Tổng quan",
        },
      },
    ],
  },
  {
    path: "",
    component: PrivacyPolicy,
    children: [
      {
        path: "chinh-sach",
        name: "PrivacyPolicy",
        component: PrivacyPolicy,
        meta: {
          title: "Đăng nhập",
          breadcrumbs: "Đăng nhập",
          breadcrumbs: "Tổng quan",
        },
      },
    ],
  },
  {
    path: "",
    component: ForBidden,
    children: [
      {
        path: "khong-co-quyen",
        name: "Login",
        component: ForBidden,
        meta: {
          title: "Không có quyền truy cập",
          breadcrumbs: "Không có quyền truy cập",
          breadcrumbs: "Không có quyền truy cập",
        },
      },
    ],
  },
  {
    path: "/in-phieu-bao-hanh/:phonbuyid",
    component: PhieuBaoHanh,
    name: "PhieuBaoHanh",
    meta: {
      title: "In phiếu bảo hành",
      breadcrumbs: "In phiếu bảo hành"
    },
  },
  {
    path: "/in-phieu-sua-chua/:phonfixid",
    component: PhieuSuaChua,
    name: "PhieuSuaChua",
    meta: {
      title: "In phiếu sửa chữa",
      breadcrumbs: "In phiếu sửa chữa"
    },
  },
  {
    path: "/in-phieu-sua-chua-cua-hang/:phonfixid",
    component: PhieuSuaChuaCuaHang,
    name: "PhieuSuaChuaCuaHang",
    meta: {
      title: "In phiếu sửa chữa",
      breadcrumbs: "In phiếu sửa chữa"
    },
  },
  {
    path: "",
    component: ServerError,
    children: [
      {
        path: "loi-xay-ra",
        name: "ServerError",
        component: ServerError,
        meta: {
          title: "Lỗi hệ thống",
          breadcrumbs: "Lỗi hệ thống",
          breadcrumbs: "Lỗi hệ thống",
        },
      },
    ],
  },
  {
    path: "",
    component: PageNotFound,
    children: [
      {
        path: "*",
        name: "PageNotFound",
        component: PageNotFound,
        meta: {
          title: "Không tìm thấy",
          breadcrumbs: "Không tìm thấy",
          breadcrumbs: "Không tìm thấy",
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
